<form class="flex-fill overflow-auto d-flex-column gap-3 pe-1 pt-2">
  @for ($guess of guesses(); track $guess; let $i = $index) {
    @if ($i < form.length) {
      <div>
        @if ($guess.label) {
          <label
            class="form-label"
            [for]="$guess.id"
          >{{$guess.label}}</label>
        }
        @if ($guess.multiline) {
          <textarea
            [formControl]="form.controls[$i]"
            id="{{$guess.id}}"
            name="{{$guess.id}}"
            class="guess-text form-control"
            [placeholder]="$guess.placeholder || 'Enter answer...'"
            [rows]="$guess.lines || 3"
          ></textarea>
        } @else {
          <input
            type="text"
            [formControl]="form.controls[$i]"
            id="{{$guess.id}}"
            name="{{$guess.id}}"
            class="guess-text form-control"
            [placeholder]="$guess.placeholder || 'Enter answer...'"
            >
        }
      </div>
    }
  }
</form>
